import { TableOfContentsProps } from 'sly/hubPage/components/HubDynamicContent/TableOfContents/TableOfContents.type';
import {
  Content,
  ContentHTMLID,
} from 'sly/hubPage/components/HubPage/HubPage.types';

const isSubtitle = ({ __component }: Content) =>
  __component?.includes('subtitle');

export default function TableOfContents({
  content,
  className,
}: TableOfContentsProps) {
  if (!content) {
    return null;
  }
  const filteredContent: ContentHTMLID[] = content.filter(isSubtitle);
  if (filteredContent.length === 0) {
    return null;
  }
  return (
    <div
      className={`mx-auto w-[calc(100%-2rem)] rounded-lg border border-solid border-[rgb(231,_232,_234)] pl-l pt-l pr-m pb-l md:mb-xl md:w-[var(--col6)] md:p-xl lg:w-[var(--col8)] ${className}`}
      data-tp-id='gen-div-f923af29-a9ee-4dff-ab8e-f12ae8104a1d'
    >
      <div
        className='font-t-l mb-l md:mb-xl'
        data-tp-id='gen-div-2697b26f-9b8c-47e4-b5d0-99f7e52f055a'
      >
        Table of Contents
      </div>
      {filteredContent.map((item, index) => {
        return (
          <a
            key={`${item.value}-${index}`}
            className='font-b-l mb-m block cursor-pointer text-viridian-base last:mb-0 hover:underline'
            href={`#${item.htmlId}`}
          >
            {item.value}
          </a>
        );
      })}
    </div>
  );
}
